const Theme = {
  backgroundColor: '#F0F0F0',
  logo_image_url: 'vdp.png',
  logo_height: 140,

  button_color: '#B3151B',
  button_border_width: 1,
  button_radius: 10,

  subtitle_font: `Nunito, sans-serif`,
  title_font: `Nunito, sans-serif`,
}

export default Theme
